import { defineMessage } from 'react-intl';

export const headI18n = {
  commentsPage: defineMessage({
    id: 'head.comments-page',
    defaultMessage: '{title} - {author} - Comments'
  })
};
